import { render } from "./ListFollowers.vue?vue&type=template&id=6ea4089f&scoped=true"
import script from "./ListFollowers.vue?vue&type=script&lang=js"
export * from "./ListFollowers.vue?vue&type=script&lang=js"

import "./ListFollowers.vue?vue&type=style&index=0&id=6ea4089f&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea4089f"]])

export default __exports__